import { faHeartCircleCheck } from '@fortawesome/free-solid-svg-icons';
import type { JSX } from 'react';
import { memo } from 'react';

import TimelineHeader from '@/pages/Timeline/components/TimelineHeader/TimelineHeader';
import TimestampAndActor from '@/pages/Timeline/components/TimestampAndActor';
import { TimelineSubcomponentProps } from '@/pages/Timeline/types';
import Card from '@/ui/components/Card';
import snakeToTitleCase from '@/utils/snakeToTitleCase';

// const dataExample = {
//   backfill: false,
//   admitted_datetime: '2023-06-20T12:00:00.000+00:00',
//   created_datetime: '2023-06-20T13:17:10.496+00:00',
//   initial_phase: 'early_intensive',
//   pending_earnings: 0.1,
//   program_name: 'Alcohol Program - Standard'
// };

const EpisodeOfCareEvent = ({ activityLog }: TimelineSubcomponentProps): JSX.Element => {
  const { action, actor, data, timestamp } = activityLog;

  return (
    <div>
      <Card>
        <TimelineHeader
          icon={faHeartCircleCheck}
          iconClassName="text-pink-700"
          title={snakeToTitleCase(action ?? '')}
        />

        {data?.program_name && <div>{data.program_name}</div>}
        {data?.initial_phase && <div>{data.initial_phase}</div>}
        {typeof data?.is_graduated === 'boolean' && (
          <div>Graduated: {data.is_graduated ? 'Yes' : 'No'}</div>
        )}
      </Card>

      <TimestampAndActor actor={actor} timestamp={timestamp} />
    </div>
  );
};

export default memo(EpisodeOfCareEvent);
